var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"staticRoot",staticClass:"qd-login-v3-mobile-root"}),_c('wise-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }